module.exports = __webpack_public_path__ + "static/media/0137_Small.bdd992d1.jpg";